module.exports = __webpack_public_path__ + "img/default-header.d687330c.png";